import { render, staticRenderFns } from "./MessagePrompt.vue?vue&type=template&id=32331319"
import script from "./MessagePrompt.vue?vue&type=script&lang=js"
export * from "./MessagePrompt.vue?vue&type=script&lang=js"
import style0 from "./MessagePrompt.vue?vue&type=style&index=0&id=32331319&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports